import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 1752 8941"
    {...props}
  >
    <path
      d="M0 7874V1061c0-354 80-618 242-795C403 89 612 0 868 0c262 0 475 87 638 262s246 441 246 799v6813c0 358-83 624-246 801-163 178-376 266-638 266-252 0-459-88-622-268C83 8494 0 8228 0 7874z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
